
import axios from "axios";
import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";

const Update = () => {
  const { memberId } = useParams();
  const navigate = useNavigate();

  const initialState = {
    address: "",
    birthAnniversary: "",
    bloodGroup: "",
    cabinetDesignation: "",
    clubs: "",
    description: "",
    designation: "",
    email: "",
    joiningDate: "",
    landlineNumber: "",
    marriageAnniversary: "",
    membershipName: "",
    membershipNo: "",
    mobile: "", // ✅ Ensure consistency
    photo: "",
    profession: "",
    profile: "",
    spouseName: "",
  };

  const [state, setState] = useState(initialState);

  const {
    address,
    birthAnniversary,
    bloodGroup,
    cabinetDesignation,
    clubs,
    description,
    designation,
    email,
    joiningDate,
    landlineNumber,
    marriageAnniversary,
    membershipName,
    membershipNo,
    mobile,
    photo,
    profession,
    profile,
    spouseName,
  } = state;

  // ✅ Function to fetch member data
  const fetchMemberData = () => {
    axios
      .get(`https://lionsdirectoryapi.emedha.in/member/api/memberMasteData/${memberId}`)
      .then((resp) => {
        console.log("Fetched Data:", resp.data);
        if (resp.data && Array.isArray(resp.data) && resp.data.length > 0) {
          setState({ ...resp.data[0] });
        }
      })
      .catch((error) => console.error("Fetch Error:", error));
  };

  useEffect(() => {
    if (memberId) {
      fetchMemberData();
    }
  }, [memberId]);

  // ✅ Function to handle input changes
  const handleInputChange = (e) => {
    setState({ ...state, [e.target.name]: e.target.value });
  };





  const updateMemberData = async (e) => {
  e.preventDefault();
  console.log("▶️ Form submitted");

  const dist = sessionStorage.getItem("dist"); // ✅ Get dist
  const performedBy = sessionStorage.getItem("email");

  try {
    let updatedPhotoUrl = state.photo;

    if (state.photo && typeof state.photo !== "string") {
      console.log("📸 Uploading new image...");
      const formData = new FormData();
      formData.append("image", state.photo);
      formData.append("mobile", state.mobile);
      formData.append("dist", dist); // ✅ Send dist

    const uploadRes = await axios.post(
        `https://lionsdirectoryapi.emedha.in/member/api/Edit-member-photo/${memberId}`,
        formData
      );

      console.log("✅ Upload response:", uploadRes.data);

      if (uploadRes.data.success && uploadRes.data.imageUrl) {
        updatedPhotoUrl = uploadRes.data.imageUrl;
      } else {
        alert("Image upload failed. Please try again.");
        return;
      }
    }

    console.log("📤 Sending update request to API...");
    const updateRes = await axios.put(
      "https://lionsdirectoryapi.emedha.in/member/api/memberMasteUpdateData",
      {
        ...state,
        dist, // ✅ Send dist
        photo: updatedPhotoUrl,
        performedBy,
        memberId,
      }
    );

    console.log("✅ Member updated:", updateRes.data);
    alert("Member updated successfully!");
    const role = sessionStorage.getItem("role");
    
    // Check if the user is a club admin to set the destination path
    const destination = role === "clubAdmin" 
        ? "/club-members" 
        : "/view-member";

    navigate(destination);
   

  } catch (error) {
    console.error("❌ Update Error:", error);
    alert("Failed to update member.");
  }
};

  

  return (
    <div>
      <form onSubmit={updateMemberData}>
        <input
          type="number"
          name="membershipNo"
          value={membershipNo}
          className="form-control"
          placeholder="Membership Number"
          required
          onChange={handleInputChange}
        />
        <br />
        <input
          type="text"
          name="membershipName"
          value={membershipName}
          className="form-control"
          placeholder="Membership Name"
          required
          onChange={handleInputChange}
        />
        <br />
        <input
          type="text"
          name="clubs"
          value={clubs}
          className="form-control"
          placeholder="Club Name"
          required
          onChange={handleInputChange}
        />
        <br />
        <input
          type="text"
          name="designation"
          value={designation}
          className="form-control"
          placeholder="Designation"
          onChange={handleInputChange}
        />
        <br />
        <input
          type="text"
          name="profession"
          value={profession}
          className="form-control"
          placeholder="Profession"
          onChange={handleInputChange}
        />
        <br />
        <input
          type="text"
          name="birthAnniversary"
          className="form-control"
          value={birthAnniversary}
          placeholder="Birth Anniversary"
          onChange={handleInputChange}
        />
        <br />
        <input
          type="text"
          name="marriageAnniversary"
          value={marriageAnniversary}
          className="form-control"
          placeholder="Marriage Anniversary"
          onChange={handleInputChange}
        />
        <br />
        <input
          type="text"
          name="bloodGroup"
          value={bloodGroup}
          className="form-control"
          placeholder="Blood Group"
          onChange={handleInputChange}
        />
        <br />
        <input
          type="text"
          name="email"
          value={email}
          className="form-control"
          placeholder="Email Id"
          onChange={handleInputChange}
        />
        <br />
        <input
          type="text"
          name="mobile"
          value={mobile}
          className="form-control"
          placeholder="Mobile number"
          onChange={handleInputChange}
        />
        <br />
        <input
          type="text"
          name="spouseName"
          value={spouseName}
          className="form-control"
          placeholder="Spouse Name"
          onChange={handleInputChange}
        />
        <br />
        <input
          type="text"
          name="address"
          value={address}
          className="form-control"
          placeholder="Address"
          onChange={handleInputChange}
        />
        <br />

        {/* Profile Picture Upload */}
        <div className="card p-1">
        {photo && (
  <img
    src={
      typeof photo === "string"
        ? photo
        : URL.createObjectURL(photo)
    }
    alt="Member"
    height="80px"
    width="80px"
    style={{ borderRadius: 40, border: "1px solid gray" }}
  />
)}

          <br />
          <input
  type="file"
  accept="image/*"
  onChange={(e) => {
    if (e.target.files && e.target.files[0]) {
      setState((prev) => ({ ...prev, photo: e.target.files[0] }));
    }
  }}
/>


        </div>

        <br />
        <button type="submit" className="btn btn-danger form-control">
          Submit
        </button>
        <br />
        <br />
        <button type="reset" className="btn btn-secondary form-control">
          Reset
        </button>
      </form>
    </div>
  );
};

export default Update;
